import React from "react";

import RecaptchaComponent from "./recaptcha";

const Recaptcha = props => <RecaptchaComponent {...props} />;

export default Recaptcha;
